/* @flow */

import React from 'react';
import { Col, Row } from 'reactstrap';
import { Paper, InfoTooltip, BookProgress } from '../components/';
import {
  DataDisplayParentContainer, IntelligencesTopicContainer, IntelligencesProgressContainer,
  ActivityFeedContainer, HeaderContainer, PageTitleContainer
} from '../containers/';
import '../../css/main.css';
import Translations from '../hocs/TranslationsHelper';
import topScroll from '../hocs/topScroll';
import {useData} from '../hocs/DataRetriever'
import { useSelector } from 'react-redux';
import { getActiveChild } from '../../selectors/children';
import { getCaligrafixBookProgressById } from '../../selectors/caligrafixBookProgress';
import _ from 'lodash';

const getCaligrafixBooksProgress = ( currentProgress, caligrafixBooks  ) => {
  return _.map(currentProgress, ({caligrafix_book_id, score})=>(
    {
      id: caligrafix_book_id,
      slug: _.find(caligrafixBooks, (b)=>(b.id==caligrafix_book_id))?.slug,
      value: parseInt(score,10)
    }
  ))
 
};
/**
 * Render Dashboard screen
 * @method Dashboard
 * @param  {object}                    translations - injected by our Translations HoC to give translated strings
 */
const Dashboard = ({ translations }) => {
  topScroll();
            
  const currentChild = useSelector(getActiveChild);
  const caligrafix_books_data = useData({id: "child_caligrafix_books_"+currentChild.id, url: 
    "/children/"+currentChild.id+"/caligrafix_book_scores/current"  });
  const {  caligrafix_books} = useSelector(({ caligrafix_books })=>({  caligrafix_books}));
  const cx_progress = caligrafix_books_data.data?.body;
  let book_progress=[];
  if(cx_progress)
    book_progress=getCaligrafixBooksProgress(cx_progress,caligrafix_books);

  return (
    <div id="dashboard" className="layout-base">
      <PageTitleContainer pageTitle="title_parent_dashboard" />
      <HeaderContainer />
      <IntelligencesTopicContainer />
      <Paper.Container lead>
        <Row>
          <Col xs="12" lg="8">
            <Paper.Title>
              <h1>{ translations.t('current_progress') }</h1>
            </Paper.Title>
          </Col>
          <Col xs="12" lg="4" className="hidden-md-down">
            <Paper.Title>
              <h1>{ translations.t('recent_activity') }</h1>
            </Paper.Title>
          </Col>
          
          <Col xs="12" lg="8">
            <Paper.Content>
              <IntelligencesProgressContainer />
            </Paper.Content>
          </Col>
          <Col xs="12" className="hidden-lg-up">
            <hr />
            <Paper.Title>
              <h1>{ translations.t('recent_activity') }</h1>
            </Paper.Title>
          </Col>
          <Col xs="12" lg="4">
            <Paper.Content>
              <ActivityFeedContainer />
            </Paper.Content>
          </Col>
          <Col lg="12" className="hidden-md-down">
            <Paper.Title>
              <h1 className="mt-5">
                { translations.t('intelligences_progress_analysis') } {' '}
                <InfoTooltip message="tooltips_intelligences_progress_analysis" />
              </h1>
            </Paper.Title>
          </Col>
          
          <Col lg="12" className="hidden-md-down">
            <Paper.Content>
              <DataDisplayParentContainer />
            </Paper.Content>
          </Col>
           
          {
            (book_progress.length>0)&&(

              <Col lg="12" className="hidden-md-down">
                <Paper.Title>
                  <h1 className="mt-5">{ translations.t('caligrafix_current_general_progress') }</h1>
                </Paper.Title>
              </Col>

            )
          }
          {
            (book_progress.length>0)&&( 

              <Col lg="12" className="hidden-md-down">
                <Paper.Content>
                  <div>  
                    {book_progress.map((book,index) =>  <BookProgress key={book.id} slug={book.slug} value={book.value} /> )}
                  </div>
                </Paper.Content>
              </Col>
            )
          }
        </Row>
      </Paper.Container>
    </div>
  );
};

export default Translations(Dashboard);
